// extracted by mini-css-extract-plugin
module.exports = {"landing_page_D2TSB":"D2TSB_landing_page_D2TSB__eXGHx"};